import { useEffect, useRef, useState } from "react";
import loaderVideo from "../../Assets/Images/Sams_Loading.mp4";

const ScreenLoader = ({ children }) => {
  const videoRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Only run once when component mounts
    setLoading(true);

    const video = videoRef.current;
    if (video) {
      video.currentTime = 0;
      video.play();
      video.onended = () => setLoading(false);
    }

    return () => {
      if (video) {
        video.onended = null;
      }
    };
  }, []); // Empty dependency array - only run once

  if (loading) {
    return (
      <div className="video-loader-container">
        <video
          ref={videoRef}
          className="video-loader"
          src={loaderVideo}
          type="video/mp4"
          muted
          autoPlay
          playsInline
        />
      </div>
    );
  }

  return <>{children}</>;
};

export default ScreenLoader;
